module.exports = __webpack_public_path__ + "img/m_bg4.4f39433c.png";